import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PopupRow {
  id: string;
  headline: string;
  body: string | null;
  cta_label: string | null;
  cta_url: string | null;
  image_url: string | null;
}

export function useActivePopup() {
  return useQuery({
    queryKey: ["active-popup"],
    queryFn: async (): Promise<PopupRow | null> => {
      const now = Date.now();
      const { data, error } = await supabase
        .from("exit_intent_popups")
        .select("id, headline, body, cta_label, cta_url, image_url, starts_at, ends_at")
        .eq("active", true)
        .order("priority", { ascending: false })
        .order("updated_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) {
        console.warn("[popup]", error.message);
        return null;
      }
      const row = data as PopupRow & { starts_at: string | null; ends_at: string | null } | null;
      if (!row) return null;
      if (row.starts_at && new Date(row.starts_at).getTime() > now) return null;
      if (row.ends_at && new Date(row.ends_at).getTime() < now) return null;
      return {
        id: row.id,
        headline: row.headline,
        body: row.body,
        cta_label: row.cta_label,
        cta_url: row.cta_url,
        image_url: row.image_url,
      };
    },
    staleTime: 60_000,
  });
}
